import mixpanel from 'mixpanel-browser';

const mixpanelKey = import.meta.env.VITE_MIXPANEL_PROJECT_KEY;

if (mixpanelKey) mixpanel.init(mixpanelKey);

const distinct_id = mixpanelKey ? mixpanel.get_distinct_id() : '';

export default {
    data: () => ({
        distinct_id,
    }),

    methods: {
        handleTrackSDK(event, options = {}) {
            if (!mixpanelKey) return;

            mixpanel.track(event, options);
        },

        navigateWithTrackingSDK(routerParams, event, options) {
            this.$router.push(routerParams);

            this.handleTrackSDK(event, options);
        },
    },
};
